"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSignInFormMessage = exports.TSignUpFormMessages = void 0;
var TSignUpFormMessages;
(function (TSignUpFormMessages) {
    TSignUpFormMessages["CustomerAlreadyExists"] = "A customer already exists with this email address";
    TSignUpFormMessages["PasswordMustBeProvided"] = "Password must be provided as a string";
    TSignUpFormMessages["CannotSendVerificationCode"] = "We couldn't send the verification code";
    TSignUpFormMessages["InvalidAccountVerificationCode"] = "The verification code isn't valid.";
    TSignUpFormMessages["AccountVerificationExpired"] = "The verification code has expired.";
    TSignUpFormMessages["EmailNotValid"] = "The email doesn't seem to be valid.";
    TSignUpFormMessages["CannotVerifyAccount"] = "We couldn't verify your account at this time. Try again";
})(TSignUpFormMessages = exports.TSignUpFormMessages || (exports.TSignUpFormMessages = {}));
var TSignInFormMessage;
(function (TSignInFormMessage) {
    TSignInFormMessage["IncorrectEmailOrPassword"] = "Incorrect email or password";
})(TSignInFormMessage = exports.TSignInFormMessage || (exports.TSignInFormMessage = {}));
//# sourceMappingURL=constants.js.map